<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end" v-if="routeName !== 'profile_job_seeker_registration'">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Registration Year</h1>
                    <span>What year do you expect to register? </span>
                </div>
                <div class="brand-icon" >
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>    
            <el-form class="full_page" :label-position="'top'" @submit.prevent="goNext('userForm')">

                <el-form-item prop="schedule" class="no-scroll form-item-skills">
                  
                    <el-select
                        v-model="form.registration_year"
                        class="skill-search-selector"
                        placeholder="Select registration year"
                        popper-class="normal-select"
                        :clearable="true">
                        <el-option
                            v-for="year in registrationYears"
                            :key="year"
                            :label="year"
                            :value="year">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="button_submit mb0">
                    <el-button :disabled="isSubmitDisabled" class="submit_page w-full" type="blue" @click="goNext('userForm')">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
        </div>
    </div>
</template>


<script>
import {
    onMounted,
    inject,
    onBeforeMount,
    ref,
    reactive,
    computed
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'
import {
    useRouter,
    useRoute
} from 'vue-router'
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon,
    },
    directives: {
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const setPageClassGlobal = inject('setPageClassGlobal');
        const $route = useRoute()
        const softwareExperienceCustomFields = ref([]);
        const routeName = $route.name;
        const userData = $store.getters.GET_USER_DATA;

        console.log("🚀 ~ setup ~ customFields:", softwareExperienceCustomFields)
        console.log($store.getters.getJobFilters.schedule);

        const form = reactive({
            registration_year: userData.registrationYear || '',

        });

        const registrationYears = computed(() => {
            const currentYear = new Date().getFullYear();
            const endYear = currentYear + 11; // Generate years for 12 years including current year
            return Array.from({ length: endYear - currentYear + 1 }, (_, i) => currentYear + i);
        });

        const rules = computed(() => {
            return {
                registration_year: { required: helpers.withMessage('Please enter the registration year', required) },
            };
        });
        const v$ = useVuelidate(rules, form);
        const goBack = async() => {
            if(routeName == "profile_job_seeker_registration"){
                $router.push({
                        name: "basic_profile_job_seeker",
                    });
            }else{
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });
            }
        };

        const isDynamicSelected = (value) => {
            return (
                form.selectedValues.includes(value.label) && value.showTextbox === true
            );
        };

        const goNext = async () => {
            const result = await v$.value.$validate();

            if (!result) {
                alert('The form has errors');
                return;
            } else {
                
                

                try {
                    await $store.dispatch("SAVE_JOB_SEEKER_SETTINGS", form);
                    if(routeName == "profile_job_seeker_registration"){
                            $router.push({
                                    name: "basic_profile_job_seeker",
                                });
                        }else{
                            $router.push({
                                name: "jobseeker_auth_cv",
                            });
                        }
                } catch (error) {
                    console.log(error);
                }
            }
        };

        const skip = () => {
            (async () => {
                try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    $router.push({
                        name: 'jobseeker_auth_cv',
                    })
                } catch (error) {
                    console.log(error);
                }
            })();
          
        }

        const validateField = (fieldName) => {
            // Trigger validation for the specified field
            v$.value[fieldName].$touch();
        };

        onMounted(() => {
            setPageClassGlobal('global_auth_registration_year_page');

        });

        onBeforeMount(async () => {
            try {
                const response = await $store.dispatch("GET_CUSTOM_FIELDS",);
                console.log("🚀 ~ onBeforeMount ~ check:", response)
                softwareExperienceCustomFields.value = response.data.softwareExperience;
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });



        const isSubmitDisabled = computed(() => {
            return Object.values(form).some(value => value.length == 0) || v$.value.$pending || v$.value.$error;
        });


        return {
            goBack,
            goNext,
            isDynamicSelected,
            softwareExperienceCustomFields, 
            form, 
            rules, 
            v$, 
            validateField, 
            isSubmitDisabled,
            skip,
            routeName,
            userData,
            registrationYears
        }
    },
}
</script>